import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row, HelpBlock } from 'react-bootstrap';
import { Input, FormActions, Select } from '../../common/components/formControls';
import TermsDropdownList from '../terms/DropdownList';
import CentersDropdownList from '../centers/DropdownList';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onReset, onSubmit, initialize, loading, waitingListStatusTypes, grades, t }) => {
	const handleReset = () => {
		initialize({});
		onReset();
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<CentersDropdownList render='field' name='centerId' label={t('WaitingList_Center')} />
						</Col>
						<Col sm={6}>
							<Field name='childName' component={Input} type='text' label={t('WaitingList_Child')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<TermsDropdownList render='field' name='termId' label={t('WaitingList_Term')} />
						</Col>
						<Col sm={6}>
							<Field name='gradeId' component={Input} componentClass='select' label={t('WaitingList_Grade')} >
								<option />
								{ui.makeOptionValues(grades)}
							</Field>
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Select name='status' label={t('WaitingList_Status')} data={waitingListStatusTypes} />
						</Col>
					</Row>
					<FormActions>
						<Button onClick={handleSubmit(values => onSubmit({ ...values }, false))} disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button onClick={handleSubmit(values => onSubmit({ ...values }, true))} disabled={loading} bsStyle='warning'>{t('Common_ExportToExcel')}</Button>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
					<HelpBlock>{t('Common_ExportHelpText')}</HelpBlock>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'waitingListFilter' })(withTranslation()(Filter));